// extracted by mini-css-extract-plugin
module.exports = {"logoImage":"LogoColor_logoImage__tCCNd","hideMeatball":"LogoColor_hideMeatball__9GF7k"};